import store from "../../Redux/store";
import { setCarbonCredits, countCarbonCredits } from "./CarbonCredits.reducer";

export function saveListCarbonCredits(records) {
  store.dispatch(setCarbonCredits(records));
}

export function saveCountCarbonCredits(count) {
  store.dispatch(countCarbonCredits(count));
}